import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import {changeStartHour} from 'topmeteo/flight-planning/actionCreators';

import Base from './Base';

const Title = _('Route start hour');

const RouteStartHour = props => (
    <Base
        {...props}
        id="route-start-hour"
        title={Title}
        icon="pin-up"
    />
);

const mapStateToProps = ({startHour: index}) => ({index});

const mapDispatchToProps = dispatch => ({
    onMove: (event, index) => dispatch(changeStartHour(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteStartHour);
